import { memo } from 'react';

import { IconNote } from '@tabler/icons-react';
import { IconButton } from 'ui-kit';

import { useDiligenceNotes } from './useDiligenceNotes';

type Props = {
  diligenceId: string;
  onClick: () => void;
};

export const DiligenceNotesIconButton = memo(function DiligenceNotesIconButton({
  diligenceId,
  onClick,
}: Props) {
  const { hasNotes } = useDiligenceNotes(diligenceId);

  return (
    <IconButton
      onClick={onClick}
      variant="icon-only"
      icon={
        <IconNote stroke={2} className={`${hasNotes ? 'text-warning-default' : 'text-white'}`} />
      }
    />
  );
});
